import { useState } from 'react'

import { Box, Icon, Text } from '@factorialco/deprecated-design-system'

import PopoverMenu from 'modules/core/components/PopoverMenu'
import i18n from 'modules/core/lib/i18n'

import type { graphViewsCostOptionEvolutionEnum } from 'modules/project_management/lib/constants'

export const CostOptions = ({
  onOptionSelect,
}: {
  onOptionSelect: (selectedOption: graphViewsCostOptionEvolutionEnum) => void
}) => {
  const [selectedOption, setSelectedOption] =
    useState<graphViewsCostOptionEvolutionEnum>('evolution')

  const handleOptionChange = (option: graphViewsCostOptionEvolutionEnum) => {
    setSelectedOption(option)
    onOptionSelect(option)
  }

  return (
    <PopoverMenu type="list">
      <PopoverMenu.Trigger>
        <Box maxWidth="s600" flexDirection="row" alignItems="center" gap="s6">
          <Box flexDirection="row" alignItems="center" gap="s6">
            <Text size="400" weight="semibold" color="grey1000">
              {selectedOption === 'evolution'
                ? i18n.t('project_management.graphs.evolution.cost.title')
                : i18n.t('project_management.graphs.breakdown.cost.title')}
            </Text>
            <Icon.Small icon="chevron-down" color="grey1000" />
          </Box>
        </Box>
      </PopoverMenu.Trigger>
      <PopoverMenu.Content side="bottom" align="start">
        <PopoverMenu.TouchableOption
          key="evolution"
          title={i18n.t('project_management.graphs.evolution.cost.title')}
          onClick={() => handleOptionChange('evolution')}
        />
        <PopoverMenu.TouchableOption
          key="breakdown"
          title={i18n.t('project_management.graphs.breakdown.cost.title')}
          onClick={() => handleOptionChange('breakdown')}
        />
      </PopoverMenu.Content>
    </PopoverMenu>
  )
}
